import styled from 'styled-components';
import { SubText as SubTextBase } from '../../../../../../../../../components/Toolkit/Inputs/SubText';

const MileageContainer = styled.div`
  display: grid;
  grid-gap: ${({ theme }) => theme.spacing.S8};
  grid-template-columns: 1fr 104px;
`;

const MileageFieldContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.M16};
`;

const SubText = styled(SubTextBase)`
  margin-top: ${({ theme }) => theme.spacing.S4};
`;

export { MileageContainer, MileageFieldContainer, SubText };
